<template>
  <div class="binding">
    <avatar-header :avatar="share && share.coach.avatar" :title="`绑定您的私人教练：${share && share.coach.name}`" />
    <component :is="currentStep.component" v-bind="currentStep.props || {}" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import weui from '@/wechat/weui';

import AvatarHeader from '@/components/AvatarHeader';
import Request from '@/components/share/Request';
import QRCode from '@/components/share/QRCode';

import { ALERT_WECHAT_BOUND, ALERT_SHARE_BOUND } from '@/constants/text';
import { SHARE_TYPE_COURSE, SHARE_TYPE_INVITE, SHARE_TYPE_TRAINER } from '@/constants/types';
import { ROUTE_SHARE_REQUEST, ROUTE_SHARE_QRCODE } from '@/router/names';
import { FETCH_SHARE, BIND_SHARE } from '@/store/share/types';
import { FETCH_WECHAT_USER, FETCH_WECHAT_TRAINER } from '@/store/wechat/types';

const { mapActions: mapShareActions, mapState: mapShareState } = createNamespacedHelpers('share');
const { mapActions: mapWechatActions, mapState: mapWechatState } = createNamespacedHelpers('wechat');

const STEP_REQUEST = 'request';
const STEP_QRCODE = 'qrcode';


export default {
    props: {
        step: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            hash: null,
        };
    },
    computed: {
        ...mapShareState({
            share: state => state.share || {},
        }),
        ...mapWechatState([
            'wechat_user',
            'trainer',
        ]),
        stepRequest() {
            return {
                component: Request,
                props: {
                    hash: this.hash,
                    stepCount: 3,
                    currentStep: 1,
                },
            };
        },
        stepQRCode() {
            return {
                component: QRCode,
                props: {
                    hash: this.hash,
                    coach: this.share && this.share.coach,
                    stepCount: 2,
                    currentStep: 1,
                    title: '请关注我们的公众号“身材觉醒”',
                },
            };
        },
        steps() {
            switch (this.share.type) {
                case SHARE_TYPE_COURSE:
                case SHARE_TYPE_TRAINER:
                    return {
                        [STEP_QRCODE]: this.stepQRCode,
                    };
                case SHARE_TYPE_INVITE:
                default:
                    return {
                        [STEP_REQUEST]: this.stepRequest,
                        [STEP_QRCODE]: Object.assign(this.stepQRCode, {
                            props: Object.assign(this.stepQRCode.props, {
                                stepCount: 3,
                                currentStep: 2,
                                title: '关注我们的公众号“身材觉醒”，就能立刻发出课程申请',
                            }),
                        }),
                    };
            }
        },
        currentStep() {
            if (this.step in this.steps) {
                return this.steps[this.step];
            }
            switch (this.share.type) {
                case SHARE_TYPE_COURSE:
                case SHARE_TYPE_TRAINER:
                    return this.steps[STEP_QRCODE];
                case SHARE_TYPE_INVITE:
                default:
                    return this.steps[STEP_REQUEST];
            }
        },
    },
    async created() {
        this.hash = this.$route.params.hash;

        await Promise.all([
            this.fetchShare({ hash: this.hash }),
            this.fetchTrainer(),
        ]);

        if (this.share.trainer) {
            // 分享可以直接关联
            if (this.share.trainer.wechat_bound) {
                // 分享已绑定
                if (this.share.trainer.wechat_openid !== this.wechat_user.openid) {
                    // 其它会员已绑定
                    await weui.alert(ALERT_SHARE_BOUND(this.share.coach.name, this.share.trainer.name));
                    this.$wechat.closeWindow();
                    return;
                }
            }
            if (this.trainer && this.trainer.id) {
                // 你已绑定了其它会员
                if (this.trainer.id !== this.share.trainer.id) {
                    await weui.alert(ALERT_WECHAT_BOUND);
                    this.$wechat.closeWindow();
                    return;
                }
            } else {
                // 未绑定
                await this.bindShare({
                    hash: this.hash,
                });
            }
        } else if (this.trainer && this.trainer.id) {
            // 邀请类型的，只能未绑定的微信用户可申请
            await weui.alert(ALERT_WECHAT_BOUND);
            this.$wechat.closeWindow();
            return;
        }

        switch (this.share.type) {
            case SHARE_TYPE_COURSE:
            case SHARE_TYPE_TRAINER:
                this.$router.replace({
                    name: ROUTE_SHARE_QRCODE,
                    params: {
                        hash: this.hash,
                    },
                });
                break;
            case SHARE_TYPE_INVITE:
            default:
                this.$router.replace({
                    name: ROUTE_SHARE_REQUEST,
                    params: {
                        hash: this.hash,
                    },
                });
                break;
        }
    },
    methods: {
        ...mapShareActions({
            fetchShare: FETCH_SHARE,
            bindShare: BIND_SHARE,
        }),
        ...mapWechatActions({
            fetchUser: FETCH_WECHAT_USER,
            fetchTrainer: FETCH_WECHAT_TRAINER,
        }),
    },
    components: {
        AvatarHeader,
        Request,
        QRCode,
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/share/Binding.vue